const user_resolver = userGetter => {
  return userId => {
    if (!(userId instanceof Array)) {
      userId = [userId];
    }
    return userId
      .map(user_id => {
        if (user_id) {
          const user = userGetter(user_id);
          if (user) {
            return user.displayName;
          } else {
            return `User: ${user_id}`;
          }
        } else {
          return null;
        }
      })
      .filter(val => val !== null);
  };
};
export default user_resolver;
